exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-elements-timeslot-style__timeSlot{display:flex!important;justify-content:center;align-items:center;padding:6px;height:32px;width:90px;border:.75px solid #adbdcc;background:#fff;border-radius:6px;cursor:pointer;font-family:Lato;font-size:14px;font-style:normal;font-weight:600;line-height:normal;letter-spacing:.14px;color:#72879b}.nil-sa-elements-timeslot-style__selected{background-color:#2b4d66!important;border-right:1px solid #223c4f!important;border-bottom:1px solid #223c4f!important;font-weight:600;color:#e6f2fb}", ""]);

// exports
exports.locals = {
	"timeSlot": "nil-sa-elements-timeslot-style__timeSlot",
	"selected": "nil-sa-elements-timeslot-style__selected"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/TimeSlot/style.less
// module id = 401
// module chunks = 0